import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, companySizesActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, companySizesActions);

export default slice.reducer;
